
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import AuthorInput from '@/components/organisms/dms/AuthorInput/AuthorInput.vue'
import StopSend from '@/components/organisms/dms/common/StopSend.vue'

export default defineComponent({
  components: {
    AuthorInput,
    StopSend,
  },
  setup () {
    const router = useRouter()
    return {
      router,
    }
  },
})
